<template>
  <div
    v-if="$store.state.modules.account.user"
    class="layout-wrapper d-lg-flex"
  >
    <!-- Start left sidebar-menu -->
    <elSideMenu />
    <!-- end left sidebar-menu -->

    <!-- start chat-leftsidebar -->
    <elLeftSidebar v-if="$route.name != 'Dashboard'" />
    <!-- end chat-leftsidebar -->

    <!-- Start User chat -->
    <elChatContainer />
    <!-- End User chat -->
  </div>
  <elWelcome v-else />
</template>

<script>
import elWelcome from "./components/Welcome.vue";
import elChatContainer from "./components/ChatContainer.vue";
import elLeftSidebar from "./components/LeftSidebar.vue";
import elSideMenu from "./components/SideMenu.vue";

export default {
  name: "Home",

  metaInfo() {
    return {
      title: "Home",
      titleTemplate: "%s | NEW ABC APP",
    };
  },

  components: {
    elChatContainer,
    elLeftSidebar,
    elSideMenu,
    elWelcome,
  },

  data() {
    return {};
  },

  mounted() {
    this.$nextTick(() => {
      if (localStorage.account) {
        this.loadRoom();
      } else {
        this.$store.state.utils.loaded = true;
      }
    });
  },

  methods: {
    loadRoom() {
      // this.$store.state.utils.loaded = false;
      this.$store.state.modules.api.getRooms("uid", 0, 12).then((resp) => {
        this.rooms = resp.data.units;
        this.$store.state.utils.loaded = true;
      });
    },
  },
};
</script>

<style>
  .user-profile-sidebar {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
  }
</style>
